import { render, staticRenderFns } from "./qrVideo.vue?vue&type=template&id=a2a48268"
import script from "./qrVideo.vue?vue&type=script&lang=js"
export * from "./qrVideo.vue?vue&type=script&lang=js"
import style0 from "./qrVideo.vue?vue&type=style&index=0&id=a2a48268&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports